import GeneralDataAdvancedSearch from './GeneralDataAdvancedSearch';
import GeneralDataDetail from './GeneralDataDetail';
import GeneralDataList from './GeneralDataList';
import GeneralDataTop from './GeneralDataTop';

const ItemTypeGeneralData = {
    Top: GeneralDataTop,
    List: GeneralDataList,
    Detail: GeneralDataDetail,
    AdvancedSearch: GeneralDataAdvancedSearch,
};

export default ItemTypeGeneralData;
